(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rb-family-desktop"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rb-family-panel')) {
    class RoyalBrandFamilyPanel extends HTMLElement {
      connectedCallback() {
        this.rootDetails = this.closest('details');
        this.updateBounds = this.updateBounds.bind(this);
        this.onToggle = () => { if (this.rootDetails.open) requestAnimationFrame(this.updateBounds); };
        this.onKeyDown = (event) => {
          if (event.key !== 'Escape') return;
          const branch = event.target.closest('details[open]');
          if (!branch || branch === this.rootDetails) return;
          event.preventDefault();
          event.stopPropagation();
          branch.open = false;
          branch.querySelector('summary').focus();
        };
        this.addEventListener('keydown', this.onKeyDown);
        this.rootDetails.addEventListener('toggle', this.onToggle);
        window.addEventListener('resize', this.updateBounds);
      }
      disconnectedCallback() {
        this.removeEventListener('keydown', this.onKeyDown);
        this.rootDetails.removeEventListener('toggle', this.onToggle);
        window.removeEventListener('resize', this.updateBounds);
      }
      updateBounds() {
        if (!this.rootDetails.open) return;
        const root = this.rootDetails.getBoundingClientRect();
        const panel = this.getBoundingClientRect();
        this.style.setProperty('--rb-panel-height', `${Math.max(72, window.innerHeight - panel.top - 16)}px`);
        this.style.left = `${Math.max(16 - root.left, Math.min(0, window.innerWidth - root.left - panel.width - 16))}px`;
      }
    }
    customElements.define('rb-family-panel', RoyalBrandFamilyPanel);
  }
  } catch(e) { console.error(e); }
})();

})();
